
(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTION = 'dp-cart-drawer';
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var drawer = document.getElementById('dp-cart-drawer');
  var lastFocus = null, scrollY = 0;

  function setCount(n) {
    document.querySelectorAll('[data-dp-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !(n > 0);
    });
  }

  function lock() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
  }
  function unlock() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function open(opener) {
    if (!drawer || drawer.classList.contains('is-open')) return;
    lastFocus = opener || document.activeElement;
    drawer.hidden = false;
    /* A forced reflow, not rAF: rAF is throttled in background tabs and a
       drawer that never gets its class stays translated off-screen. */
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lock();
    var first = drawer.querySelector('[data-dp-drawer-initial]') || drawer.querySelector(FOCUSABLE);
    if (first) first.focus();
  }

  function close() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlock();
    /* transitionend never fires when the transition does not run (reduced
       motion, a hidden tab), so a timer backs it up — otherwise the closed
       drawer stays in the accessibility tree. */
    var done = false;
    function settle() { if (done) return; done = true; drawer.hidden = true; }
    drawer.addEventListener('transitionend', settle, { once: true });
    setTimeout(settle, 450);
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }

  function refresh() {
    return fetch(ROOT + '?sections=' + SECTION)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION];
        if (!html || !drawer) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html')
          .querySelector('[data-dp-cart-contents]');
        var here = drawer.querySelector('[data-dp-cart-contents]');
        if (fresh && here) here.innerHTML = fresh.innerHTML;
      });
  }

  function cartJson() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); return cart; });
  }

  function added() {
    return cartJson().then(refresh).then(function () { open(); });
  }

  function busy(btn, on, label) {
    if (!btn) return;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    if (btn.tagName === 'BUTTON') btn.disabled = on;
    if (on) { btn.dataset.dpLabel = btn.innerHTML; btn.textContent = label; }
    else if (btn.dataset.dpLabel) { btn.innerHTML = btn.dataset.dpLabel; }
  }

  /* Add-to-cart LINKS: every Buy / Add to cart on a designed product page. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-dp-add]');
    if (!a || !drawer) return;
    e.preventDefault();
    busy(a, true, 'Adding…');
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(a.getAttribute('data-dp-add')), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(added)
      .catch(function () { window.location.href = a.href; })
      .finally(function () { busy(a, false); });
  });

  /* Add-to-cart FORMS: the generic product page, the search results. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !drawer || form.hasAttribute('data-dp-no-drawer')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    busy(btn, true, 'Adding…');
    fetch(ROOT + 'cart/add.js', {
      method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(added)
      .catch(function () { form.setAttribute('data-dp-no-drawer', ''); form.submit(); })
      .finally(function () { busy(btn, false); });
  });

  /* Quantity steps and removals inside the drawer and on the cart page. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dp-cart-change]');
    if (!b) return;
    e.preventDefault();
    if (drawer) drawer.classList.add('is-busy');
    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(b.getAttribute('data-line')),
                             quantity: Number(b.getAttribute('data-dp-cart-change')) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        /* The cart page is server-rendered; reload it rather than keep two
           renderings of the same lines in step. */
        if (document.querySelector('[data-dp-cart-page]')) { window.location.reload(); return; }
        return refresh();
      })
      .finally(function () { if (drawer) drawer.classList.remove('is-busy'); });
  });

  /* The header cart icon opens the drawer; it is still a link to /cart. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-dp-cart-open]');
    if (!t || !drawer || document.querySelector('[data-dp-cart-page]')) return;
    e.preventDefault();
    open(t);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-dp-drawer-close]')) { e.preventDefault(); close(); }
  });

  /* Focus trap and Escape. */
  document.addEventListener('keydown', function (e) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE),
      function (n) { return n.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* A page restored from the back/forward cache shows the count it was left
     with; re-read it. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) cartJson(); });

  /* Forms. Shopify's contact and customer endpoints redirect back with
     ?contact_posted=true / ?customer_posted=true; which form on the page sent
     it is remembered across that redirect, and its confirmation is shown. */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-dp-form]');
    if (f) { try { sessionStorage.setItem('dp-sent', f.getAttribute('data-dp-form')); } catch (x) {} }
  });
  if (/[?&](contact|customer)_posted=true/.test(window.location.search)) {
    var id = null;
    try { id = sessionStorage.getItem('dp-sent'); sessionStorage.removeItem('dp-sent'); } catch (x) {}
    var note = id && document.querySelector('[data-dp-sent="' + id + '"]');
    if (note) { note.hidden = false; note.scrollIntoView({ block: 'center' }); }
  }

  window.DJIPowerCart = { open: open, close: close, refresh: refresh };
}());
